import {
  Box,
  Button,
  Container,
  Grid,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import Diversity3Icon from "@mui/icons-material/Diversity3";

const Keypoints = () => {
  const theme = useTheme();

  return (
    <Container
      sx={{ mt: { xs: 35, md: 25, lg: 2 }, mb: { xs: 20, md: 18, lg: 20 } }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems="center"
        spacing={5}
      >
        {/* Left AI-themed Illustration */}
        <Box
          component="img"
          src="https://ghorami.com/image/atop_banner/left_freelancer_home.png"
          alt="AI Freelancer"
          sx={{ width: { xs: "90%", md: "45%" }, borderRadius: 4 }}
        />

        {/* Right Text Content */}
        <Stack spacing={3} sx={{ width: { xs: "100%", md: "55%" } }}>
          <Typography
            variant="subtitle1"
            sx={{ color: "#6E6E73", fontWeight: 600, letterSpacing: 1 }}
          >
            ⚡ AI-powered freelancing for modern pros
          </Typography>

          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              background: "linear-gradient(to right, #00BFA6, #2F80ED)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Get Discovered. Work Smarter.
          </Typography>

          <Typography
            sx={{ fontSize: "15px", color: "#6F6F70", fontWeight: 500 }}
          >
            Songjukti helps you find purpose-driven projects, match
            intelligently with clients, and deliver results with creativity and
            freedom — powered by smart algorithms and a growing global
            community.
          </Typography>

          {/* Key Points */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Stack direction="row" spacing={2} alignItems="center">
                <RocketLaunchIcon sx={{ color: "#009C8B" }} />
                <Typography fontWeight={600}>
                  Launch your career from anywhere
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Stack direction="row" spacing={2} alignItems="center">
                <PsychologyAltIcon sx={{ color: "#009C8B" }} />
                <Typography fontWeight={600}>
                  Work your way with full flexibility
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Stack direction="row" spacing={2} alignItems="center">
                <AutoAwesomeIcon sx={{ color: "#009C8B" }} />
                <Typography fontWeight={600}>
                  AI-matching with meaningful projects
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Diversity3Icon sx={{ color: "#009C8B" }} />
                <Typography fontWeight={600}>
                  Connect with top global teams
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          <Button
            onClick={() =>
              window.open("https://community.ghorami.com/forum/", "_blank")
            }
            variant="contained"
            size="large"
            sx={{
              mt: 2,
              width: "fit-content",
              borderRadius: "25px",
              px: 4,
              py: 1.5,
              fontWeight: 600,
              fontSize: "14px",
              background: "linear-gradient(to right, #00BFA6, #2F80ED)",
              color: "#fff",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              "&:hover": {
                background: "linear-gradient(to right, #009C8B, #1B7BE0)",
              },
            }}
          >
            Explore Community
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
};

export default Keypoints;
